import { UnAuthorizedView } from "@/components/unauthorized-view/UnAuthorizedView";
import { HandleRebatesView } from "@/features/rebates/components/HandleRebatesView";
import {
  defaultHandleRebatesGoalStatusCodes,
  RebatesFilterProvider,
} from "@/features/rebates/components/rebates-filter/RebatesFilterContext";
import { hasClaim } from "@/lib/claims/utils";
import { profileSelectors } from "@/redux/profile/selectors";
import { OPEN_REBATE } from "@/types/claims/constants";
import { Card, stenaTags } from "@stenajs-webui/elements";
import { PageHeader } from "@/components/page-header/PageHeader";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";

import { cssColor } from "@stenajs-webui/theme";
import { PageLayout } from "@/components/page-layout/PageLayout";

export const HandleRebates = () => {
  const { claims } = useSelector(profileSelectors.getGlobal);

  return (
    <>
      <Helmet title="Rebates - FPP" />

      {hasClaim(claims, [OPEN_REBATE]) ? (
        <>
          <PageHeader title="Rebates - Handle" icon={stenaTags} />

          <PageLayout>
            <Card>
              <RebatesFilterProvider
                initialGoalStatusCodes={defaultHandleRebatesGoalStatusCodes}
              >
                <HandleRebatesView />
              </RebatesFilterProvider>
            </Card>
          </PageLayout>
        </>
      ) : (
        <UnAuthorizedView />
      )}
    </>
  );
};
